import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import once from 'lodash.once';
import { SPRING_OFFER_RANGES } from '@/constants/springOffer';

dayjs.extend(isBetween);

const isAcceptEnv =
	process.env.NEXT_PUBLIC_TARGET_ENV === 'accept' ||
	process.env.NEXT_PUBLIC_TARGET_ENV === 'nightly';
const SPRING_PROMO_START = dayjs(
	isAcceptEnv ? SPRING_OFFER_RANGES.accept.start : SPRING_OFFER_RANGES.prod.start
);
const SPRING_PROMO_END = dayjs(
	isAcceptEnv ? SPRING_OFFER_RANGES.accept.end : SPRING_OFFER_RANGES.prod.end
);

export const showSpringOffer = once(() => {
	if (process.env.NEXT_PUBLIC_LANGUAGE !== 'cs') {
		return false;
	}

	const now = dayjs();
	return now.isBetween(SPRING_PROMO_START, SPRING_PROMO_END, 'second', '[]');
});
